import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap'; // Importa la biblioteca de modales de Bootstrap
import axios from 'axios';

const PreviewDoc = ({ filePath, status, text }) => {
  const [showModal, setShowModal] = useState(false); // Estado para controlar la visibilidad del modal
  const [pdfURL, setPDFURL] = useState('');

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const visualizarArchivo = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/documents/download`,
        {
          params: { path: filePath },
          responseType: 'blob',
        }
      );

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const urlPDF = URL.createObjectURL(blob);
      setPDFURL(urlPDF);
    } catch (error) {
      console.error('Error al obtener el documento:', error);
    }
  };

  // Llama a la función para visualizar el archivo al montar el componente
  useEffect(() => {
    if (filePath) visualizarArchivo();
  }, [filePath]);

  return (
    <>
      {text ? (
        <span className="text-primary" style={{ cursor: 'pointer' }} onClick={handleOpenModal}>
          <i className="fa fa-download ms-2 me-1"></i>
          {text}
        </span>
      ) : (
        <i
          className={`${
            status === 'ok' ? 'fa fa-check text-success' : 'fa fa-exclamation-triangle text-warning'
          }`}
          onClick={handleOpenModal}
          style={{ cursor: 'pointer' }}
        ></i>
      )}
      {/* Modal de Bootstrap */}
      <Modal show={showModal} onHide={handleCloseModal} className="modal-lg">
        <Modal.Header closeButton>
          <Modal.Title>Vista previa del documento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Aquí debes mostrar el contenido del archivo dentro del modal */}
          {filePath && <embed src={pdfURL} type="application/pdf" width="100%" height="600px" />}
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cerrar
          </Button>
        </Modal.Footer> */}
      </Modal>
    </>
  );
};

export default PreviewDoc;
